import { Component } from '@angular/core';

@Component({
  selector: 'app-validators-config',
  templateUrl: './config.component.html',
  styleUrls: ['./config.component.css']
})

export class ValidatorsConfigComponent {
  first = 0;
}
